/* KBW Before & After — autoplay for the two photograph strips.

   Layered on top of the shared slider (`kbw-slider.js`) instead of changing it:
   that file also drives the hero, the collection row and the buyer programme,
   and none of them should move because this page wants autoplay. It only
   presses the strip's own "next" button, or its first dot to start over, so
   the shared script still does the scrolling and keeps the dots honest.

   Each strip has its own timer. Nothing here knows the other strip exists.

   Rules (client, 2026-10-06):
   - advances every `data-ba-interval` seconds, from the last slide back to
     the first
   - pauses while the mouse is over the strip, while a finger or a mouse drag is
     on it, and while a control inside it has keyboard focus
   - after that interaction ends it waits a full interval before moving again
   - an arrow or dot press restarts the countdown
   - never runs for a visitor who asked for reduced motion, and stops while the
     tab is hidden

   Markup contract: [data-kbw-slider][data-ba-autoplay="true"][data-ba-interval]
*/
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    if (root.dataset.baAutoplayReady === '1') return;
    if (root.dataset.baAutoplay !== 'true') return;

    var next = root.querySelector('[data-kbw-next]');
    var dots = root.querySelectorAll('[data-kbw-dot]');
    // One photograph: no arrows, no dots, nothing to advance.
    if (!next || dots.length < 2) return;

    root.dataset.baAutoplayReady = '1';

    var delay = (parseInt(root.dataset.baInterval, 10) || 5) * 1000;
    var timer = null;
    var holds = 0;

    function activeIndex() {
      for (var i = 0; i < dots.length; i++) {
        if (dots[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function advance() {
      var last = -1;
      for (var i = 0; i < dots.length; i++) {
        if (!dots[i].hidden) last = i;
      }
      if (last > 0 && activeIndex() >= last) dots[0].click();
      else next.click();
      schedule();
    }

    function clear() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function schedule() {
      clear();
      if (holds > 0 || document.hidden || reduced.matches) return;
      timer = window.setTimeout(advance, delay);
    }

    function hold() { holds++; clear(); }
    function release() { holds = Math.max(0, holds - 1); schedule(); }

    // Pointer: a mouse hovering, or any pointer pressed on the strip.
    var hovering = false;
    root.addEventListener('mouseenter', function () {
      if (hovering) return;
      hovering = true; hold();
    });
    root.addEventListener('mouseleave', function () {
      if (!hovering) return;
      hovering = false; release();
    });

    var touching = false;
    function touchStart() { if (!touching) { touching = true; hold(); } }
    function touchEnd() { if (touching) { touching = false; release(); } }
    root.addEventListener('touchstart', touchStart, { passive: true });
    root.addEventListener('touchend', touchEnd, { passive: true });
    root.addEventListener('touchcancel', touchEnd, { passive: true });

    var pressed = false;
    function pressEnd() {
      if (!pressed) return;
      pressed = false;
      window.removeEventListener('pointerup', pressEnd);
      window.removeEventListener('pointercancel', pressEnd);
      release();
    }
    root.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || pressed) return;
      pressed = true; hold();
      window.addEventListener('pointerup', pressEnd);
      window.addEventListener('pointercancel', pressEnd);
    });

    var focused = false;
    root.addEventListener('focusin', function () {
      if (!focused) { focused = true; hold(); }
    });
    root.addEventListener('focusout', function () {
      if (focused) { focused = false; release(); }
    });

    // A person pressed an arrow or a dot: the countdown starts over. The
    // clicks this script makes itself are not trusted events and are ignored.
    root.addEventListener('click', function (event) {
      if (event.isTrusted && event.target.closest('[data-kbw-prev], [data-kbw-next], [data-kbw-dot]')) {
        schedule();
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clear(); else schedule();
    });
    var onMotion = function () { if (reduced.matches) clear(); else schedule(); };
    if (reduced.addEventListener) reduced.addEventListener('change', onMotion);

    schedule();
  }

  function setupAll() {
    var roots = document.querySelectorAll('[data-kbw-slider][data-ba-autoplay="true"]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }
  document.addEventListener('shopify:section:load', setupAll);
})();
